import { bookingSourceLabel, type BookingSource } from '@/calendar/bookingSource';
import { AirbnbIcon } from '@/components/icons/AirbnbIcon';

/** Ícono de origen: Airbnb / OTA vs Interactive Talker. */
export function BookingSourceIcon({
  bookingOrigin,
  otaChannel,
  conversationChannel,
  size = 15,
}: BookingSource & { size?: number }) {
  const label = bookingSourceLabel({ bookingOrigin, otaChannel, conversationChannel });
  const s = size;

  if (bookingOrigin === 'ota') {
    if (otaChannel === 'airbnb') {
      return (
        <span title={label} aria-label={label} role="img" style={{ display: 'inline-flex', flexShrink: 0 }}>
          <AirbnbIcon size={s} />
        </span>
      );
    }
    return (
      <span
        title={label}
        aria-label={label}
        role="img"
        style={{ display: 'inline-flex', flexShrink: 0, fontSize: Math.max(10, size - 2) }}
      >
        🌐
      </span>
    );
  }

  return (
    <span title={label} aria-label={label} role="img" style={{ display: 'inline-flex', flexShrink: 0 }}>
      <img src="/logo.png" alt="" width={s} height={s} style={{ display: 'block', objectFit: 'contain' }} />
    </span>
  );
}
